import React, { useState, forwardRef, useImperativeHandle, useEffect, useMemo } from 'react'
import { Button, Input, Space, Form, Switch, Table, InputNumber, Row, Col, Radio } from 'antd'
import { SBack, SSegmentedTabs, STableActions, SActionBtn, STitle } from 'shj-components'
import PaySetModal from '../components/PaySetModal'
import { getEnums } from '@/services/homeService.ts'
import { useSetState } from 'ahooks'
import {
  goodsManagementGetPrdArgManageListByGoodsId,
  goodsManagementGetSaleConfigByParam,
} from '@/services/goods.ts'
import StoreSetModal from '@/pages/commodityEdit/components/StoreSetModal.tsx'
import { isBoolean } from 'lodash'
import { useParams } from 'react-router-dom'

const SecondContent = forwardRef(({ setDealWay, goodsId, copyId, isEdit, detail }: any, ref) => {
  const [form] = Form.useForm()
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [openPaySetModal, setOpenPaySetModal] = useState(false)
  const distribution = Form.useWatch('deliveryType', form)
  const [data, setData] = useState([])
  const { id } = useParams()

  const [state, setState] = useSetState<any>({
    distributionList: [],
    mathList: [],
    dealList: [],
    prdBizTagList: [],
    budgetList: [],
    open: false, // 库存设置
    virInvFlag: true,
    record: {},
    initValues: { deliveryType: 'DEMAND', virInvFlag: true },
  })

  useEffect(() => {
    getOptions()
  }, [goodsId, copyId, detail])

  const otherColumns: any[] = useMemo(() => {
    const skuArgs: any[] = data[0]?.skuJson?.skuArgs || []
    return skuArgs.map((item, skuI) => ({
      title: item.argName,
      dataIndex: 'skuJson',
      width: 120,
      ellipsis: true,
      render: v => {
        const current = v.skuArgs?.[skuI]
        return current.argVal || current.argValName
      },
    }))
  }, [data])

  const getOptions = () => {
    if (!goodsId && !copyId) return
    Promise.all([
      mapEnums('DeliveryTypeEnum'),
      mapEnums('StockMathTypeEnum'),
      mapEnums('DealTypeEnum'),
      mapEnums('PriceCreatedTypeEnum'),
      goodsManagementGetPrdArgManageListByGoodsId({ goodsId: copyId || goodsId }),
      goodsManagementGetSaleConfigByParam({ goodsId: copyId || goodsId }),
    ]).then(res => {
      const [distributionList, mathList, dealList, prdBizTagList, budgetList, paramRes] = res
      const { skuInfoList = [] } = paramRes
      setState({
        initValues: { ...state.initValues, ...paramRes },
        virInvFlag: isBoolean(paramRes.virInvFlag) ? paramRes.virInvFlag : true,
      })
      form.setFieldsValue({ ...state.initValues, ...paramRes })
      setData(skuInfoList)
      if (!id || !paramRes.dealType) {
        // 新增状态，设置默认值
        const value =
          !(budgetList as Array<any>)?.length || detail.bizTagCode === 'productTypeRetail'
            ? dealList[0]?.value
            : dealList[1]?.value
        form.setFieldValue('dealType', value)
        setDealWay(value)
      } else {
        setDealWay(paramRes.dealType)
      }
      setState({ distributionList, mathList, dealList, prdBizTagList, budgetList })
    })
  }

  const mapEnums = async (type: string) => {
    const data = await getEnums('plus-goods', `com.shj.saas.plus.goods.enums.${type}`)
    return data?.map(item => ({ value: item.key, label: item.description }))
  }

  useImperativeHandle(ref, () => ({
    form,
  }))

  const onEdit = (record: any) => {
    setOpenPaySetModal(true)
    setState({ record })
  }

  const onEditStore = record => {
    setState({ open: true, record })
  }

  const columns = [
    {
      title: 'SKU编码',
      dataIndex: 'id',
      width: 200,
    },
    ...otherColumns,
    {
      title: '零售价生成',
      dataIndex: 'priceCreatedTypeStr',
      width: 160,
    },
    {
      title: '零售价 (元)',
      dataIndex: 'price',
      width: 160,
    },
    {
      title: '库存量',
      dataIndex: 'stockNum',
      width: 160,
      hidden: state.virInvFlag,
    },
    {
      title: '操作',
      dataIndex: 'operate',
      fixed: 'right',
      width: 200,
      render: (_, record) => (
        <STableActions>
          <SActionBtn onClick={() => onEdit(record)}>价格编辑</SActionBtn>
          {distribution === 'INVENTORY' && !state.virInvFlag && (
            <SActionBtn onClick={() => onEditStore(record)}>库存配置</SActionBtn>
          )}
        </STableActions>
      ),
    },
  ]

  const onSelectChange = selectedRowKeys => {
    setSelectedRowKeys(selectedRowKeys)
  }

  const rowSelection = {
    onChange: onSelectChange,
  }

  const dealWayChange = (way: any) => {
    setDealWay(way?.target?.value)
  }

  const handleClosePaySetModal = () => {
    setOpenPaySetModal(false)
    setState({ record: {} })
  }

  const handleOpenPaySetModal = () => {
    setOpenPaySetModal(true)
  }

  const onEditTableData = values => {
    const newData = data.map(item => {
      if (selectedRowKeys.includes(item.id) || state.record?.id === item.id) {
        item = { ...item, ...values }
      }
      return item
    })
    setData(newData)
  }

  useImperativeHandle(ref, () => ({
    form,
    getFormData: { ...form.getFieldsValue(), skuInfoList: data, goodsId },
  }))

  return (
    <div>
      <Form
        form={form}
        initialValues={state.distributionList.length && state.initValues}
        name="basicInfo"
      >
        <Row gutter={10}>
          <Form.Item hidden name="id">
            <Input />
          </Form.Item>
          {/* <Col span={24}>
            <STitle title={'显示价格'} titleMode={'edit'} style={{ marginBottom: 10 }} />
          </Col>
          <Col span={6}>
            <Form.Item
              name="deliveryType"
              label="显示位数"
              layout={'vertical'}
              rules={[
                {
                  required: true,
                  message: '请选择配货方式',
                },
              ]}
              initialValue={state.distributionList[0]?.value}
            >
              <Radio.Group options={state.distributionList} style={{ padding: 0 }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="deliveryType"
              label="取数规则"
              layout={'vertical'}
              rules={[
                {
                  required: true,
                  message: '请选择配货方式',
                },
              ]}
              initialValue={state.distributionList[0]?.value}
            >
              <Radio.Group options={state.distributionList} style={{ padding: 0 }} />
            </Form.Item>
          </Col> */}
          <Col span={24}>
            <STitle title={'库存设置'} titleMode={'edit'} style={{ marginBottom: 10,marginTop: 20}} />
          </Col>
          <Col span={6}>
            <Form.Item
              name="deliveryType"
              label="配货方式"
              layout={'vertical'}
              rules={[
                {
                  required: true,
                  message: '请选择配货方式',
                },
              ]}
              initialValue={state.distributionList[0]?.value}
            >
              <Radio.Group options={state.distributionList} style={{ padding: 0 }} />
            </Form.Item>
          </Col>
          {distribution === 'INVENTORY' && (
            <>
              <Col span={6}>
                <Form.Item
                  name="virInvFlag"
                  label="是否虚拟库存"
                  layout={'vertical'}
                  rules={[
                    {
                      required: true,
                      message: '请选择是否虚拟库存',
                    },
                  ]}
                  valuePropName="checked"
                  initialValue={true}
                >
                  <Switch
                    checkedChildren="是"
                    unCheckedChildren="否"
                    onChange={(v: boolean) => setState({ virInvFlag: v })}
                  />
                </Form.Item>
              </Col>

              {state.virInvFlag ? (
                <Col span={6}>
                  <Form.Item
                    name="stockNum"
                    layout={'vertical'}
                    label="库存量"
                    rules={[
                      {
                        required: true,
                        message: '请填写库存量',
                      },
                      {
                        pattern: /^[1-9]\d*$/,
                        message: '请填写正确的库存量',
                      },
                    ]}
                    // style={{
                    //   width: 400
                    // }}
                  >
                    <Input placeholder={'请填写库存量'} />
                  </Form.Item>
                </Col>
              ) : (
                <>
                  <Col span={6}>
                    <Form.Item
                      name="stockMathType"
                      layout={'vertical'}
                      label="库存计数方式"
                      rules={[
                        {
                          required: true,
                          message: '请选择库存计数方式',
                        },
                      ]}
                      initialValue={state.mathList[0]?.value}
                    >
                      <Radio.Group options={state.mathList} style={{ padding: 0 }} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="autoDelisting"
                      label="库存0是否自动下架"
                      layout={'vertical'}
                      rules={[
                        {
                          required: true,
                          message: '请选择库存0是否自动下架',
                        },
                      ]}
                      valuePropName="checked"
                      initialValue={true}
                    >
                      <Switch checkedChildren="是" unCheckedChildren="否" />
                    </Form.Item>
                  </Col>
                </>
              )}
            </>
          )}
          <Col span={24}>
            {' '}
            <STitle
              title={'成交与交付'}
              titleMode={'edit'}
              style={{ marginBottom: 10, marginTop: 20 }}
            />
          </Col>
          <Form.Item
            name="dealType"
            layout={'vertical'}
            label="成交方式"
            rules={[
              {
                required: true,
                message: '请选择成交方式',
              },
            ]}
            initialValue={state.dealList[0]?.value}
          >
            <Radio.Group
              disabled={isEdit}
              onChange={dealWayChange}
              options={state.dealList}
              style={{ padding: 0 }}
            />
          </Form.Item>
          <Col span={24}>
            {' '}
            <STitle
              title={'SKU设置'}
              titleMode={'edit'}
              style={{ marginBottom: 10, marginTop: 20 }}
            />
          </Col>
        </Row>
      </Form>
      <div style={{ marginRight: 30, overflowX: 'hidden' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
          <Button
            type="primary"
            disabled={selectedRowKeys.length <= 0}
            onClick={handleOpenPaySetModal}
          >
            批量编辑
          </Button>
        </div>
        <Table
          rowKey={'id'}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data}
          scroll={{ x: '100%' }}
        />
      </div>
      <PaySetModal
        open={openPaySetModal}
        record={state.record}
        prdBizTagList={state.prdBizTagList}
        onChangeTableData={onEditTableData}
        onClose={handleClosePaySetModal}
      />
      {state.open && (
        <StoreSetModal
          open={state.open}
          record={state.record}
          onChangeTableData={onEditTableData}
          onClose={() => setState({ open: false, record: {} })}
        />
      )}
    </div>
  )
})

export default SecondContent
